import AuthService from '@/services/auth-service'
import common from '@/utils/common'

const user = common.methods.isEmpty(localStorage.getItem('user'))
  ? null
  : JSON.parse(localStorage.getItem('user'))
const initialState = user
  ? {
      status: { loggedIn: true },
      user,
      isUserPermitAll: localStorage.getItem('isUserPermitAll')
    }
  : {
      status: {},
      user: null,
      isUserPermitAll: localStorage.getItem('isUserPermitAll')
    }

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        (user) => {
          commit('loginSuccess', user)
          return Promise.resolve(user)
        },
        (error) => {
          commit('loginFailure')
          return Promise.reject(error.response.data)
        }
      )
    },
    logout({ commit }) {
      AuthService.logout()
      commit('logout')
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        (data) => {
          commit('registerSuccess')
          return Promise.resolve(data)
        },
        (error) => {
          commit('registerFailure')
          return Promise.reject(error.response.data)
        }
      )
    },
    checkAccessToken({ commit, state }) {
      return AuthService.checkAccessToken(state.user.access_token).then(
        (user) => {
          return Promise.resolve(user)
        },
        (error) => {
          commit('loginFailure')
          return Promise.reject(error.response.data)
        }
      )
    },
    refreshToken({ commit, state }) {
      return AuthService.refreshToken(state.user.refresh_token).then(
        (user) => {
          commit('loginSuccess', user)
          return Promise.resolve(user)
        },
        (error) => {
          commit('loginFailure')
          return Promise.reject(error.response.data)
        }
      )
    },
    socialLogin({ commit }, account) {
      return AuthService.socialLogin(account).then(
        (user) => {
          commit('loginSuccess', user)
          return Promise.resolve(user)
        },
        (error) => {
          return Promise.reject(error.response.data)
        }
      )
    }
  },
  mutations: {
    loginSuccess: (state, user) => {
      state.status = { loggedIn: true }
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    loginFailure: (state) => {
      state.status = {}
      state.user = null
    },
    logout: (state) => {
      state.status = {}
      state.user = null
    },
    registerSuccess: (state) => {
      state.status = {}
    },
    registerFailure: (state) => {
      state.status = {}
    }
  }
}
